import { createAction } from 'redux-actions';
import {
  closeSocketClientRequest,
  //   removeUserFromRoom,
} from 'api/project-socket-client-api';
import { isSignalRForSocketConnectionEnabled } from 'api/api-constants';
import { updateSelectedProject } from './common/selected-project-actions';
import { requestGetStatementList } from './common/statement-list-actions';
import { clearStatementWorkflows } from './statement-workflows-actions';
import { STATEMENT_LIST_TABS } from 'constants/feature/statement-list-constants';

export const setProjectSocketClient = createAction('SET_PROJECT_SOCKET_CLIENT');

export const initProjectSocketIOSocketClient = createAction(
  'INIT_PROJECT_SOCKETIO_SOCKET_CLIENT',
);

export const initProjectSignalrSocketClient = createAction(
  'INIT_PROJECT_SIGNALR_SOCKET_CLIENT',
);

export const clearProjectSocketClientInStore = createAction(
  'CLEAR_PROJECT_SOCKET_CLIENT',
);

export const stopProjectSocketConnection = createAction(
  'STOP_PROJECT_SOCKET_CONNECTION',
);

export const initProjectSocketClient =
  (projectId) => async (dispatch, getState) => {
    const { data: { currentUser } = {} } = getState();
    const { data: { projectToGeoMap } = {} } = currentUser || {};
    const geoCode = projectId
      ? (projectToGeoMap.get(`${projectId}`) || {}).geoCode
      : null;
    if (isSignalRForSocketConnectionEnabled) {
      await dispatch(
        initProjectSignalrSocketClient({ projectId, geoCode, dispatch }),
      );
    } else {
      await dispatch(
        initProjectSocketIOSocketClient({
          projectId,
          geoCode,
          dispatch,
          currentUser,
        }),
      );
    }
  };

export const closeProjectSocketClient =
  (projectId) => async (dispatch, getState) => {
    await dispatch(stopProjectSocketConnection());
    await dispatch(clearProjectSocketClientInStore());
    try {
      if (isSignalRForSocketConnectionEnabled) {
        const connectionId = localStorage.getItem('projectConnectionId');
        await closeSocketClientRequest({
          projectId,
          connectionId,
        });
      }
    } catch (error) {
      console.error(error);
    }
  };

export const updateProjectSocketClient =
  (webSocketPayload) => async (dispatch, getState) => {
    const { data, ui } = getState();
    const {
      workflowsMap,
      statementList: {
        statementListFilters: { selectedTab },
      },
    } = data;
    const { statementPage } = ui;
    const selectedStatementsTab = selectedTab;
    const { statementWorkflowSteps } = statementPage;

    if (workflowsMap) {
      workflowsMap.getWorkflowsListData().forEach((workflow) => {
        if (
          workflow.status ===
          statementWorkflowSteps.isCompletedWorkFlowStep(
            workflow.documentProcessTypeEnum,
          ).status
        ) {
          if (webSocketPayload['clientLegalHold']) {
            dispatch(
              updateSelectedProject({
                projectId: webSocketPayload.clientId,
                clientLegalHold: webSocketPayload.clientLegalHold,
              }),
            );
          }
          if (selectedStatementsTab === STATEMENT_LIST_TABS.ACTIVE)
            dispatch(requestGetStatementList({ withLoading: false }));
          dispatch(clearStatementWorkflows());
        }
      });
    }
  };
